export const getTimeframeIndexedPath = (index: number) => {
  return `timeframes.${index}` as const;
};
